
export const combineSortAndDirection = (sort, sortDirection) => {
  const prefix = sortDirection === 'desc' ? '-' : '+';

  return sort ? prefix + sort : undefined;
};
